import React from 'react';
import { FileText, Book } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

interface LectureHeaderProps {
  title: string;
  subtitle: string;
  duration?: string;
  lastUpdated?: string;
  showSeparator?: boolean;
}

/**
 * A standardized header component for lecture pages
 */
const LectureHeader: React.FC<LectureHeaderProps> = ({ 
  title, 
  subtitle, 
  duration = '45 minutes', 
  lastUpdated = 'April 2025',
  showSeparator = true
}) => {
  return (
    <div className="mb-8">
      <h1 className="text-3xl md:text-4xl font-serif font-bold text-[#2C3E50] mb-4">
        {title}
      </h1>
      <p className="text-[#7F8C8D] mb-6">
        {subtitle}
      </p>
      <div className="flex items-center gap-3 mb-8">
        <div className="flex items-center text-sm text-[#7F8C8D]">
          <FileText className="h-4 w-4 mr-1" />
          <span>Lecture Duration: {duration}</span>
        </div>
        <div className="w-1 h-1 rounded-full bg-gray-300"></div>
        <div className="flex items-center text-sm text-[#7F8C8D]">
          <Book className="h-4 w-4 mr-1" />
          <span>Last Updated: {lastUpdated}</span>
        </div>
      </div>
      
      {showSeparator && <Separator className="mb-8" />}
    </div>
  );
};

export default LectureHeader;